class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
          	if ( window.KST_REC ) window.KST_REC.init(this);
          }
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);

/* Kopstorm, 23 Aug 2026: Splide slider for the cart upsell rail.
   The recommendations markup is injected with innerHTML, so a script tag inside
   the section would never execute. Splide is loaded once from the CDN (same
   version and source the other Kopstorm sliders use) and mounted from here. */
window.KST_REC = window.KST_REC || (function () {

	var SPLIDE_JS  = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
	var SPLIDE_CSS = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
	var loading = null;

	function loadSplide() {
		if ( typeof Splide !== 'undefined' ) return Promise.resolve();
		if ( loading ) return loading;

		loading = new Promise(function (resolve, reject) {
			if ( !document.querySelector('link[href="' + SPLIDE_CSS + '"]') ) {
				var link = document.createElement('link');
				link.rel = 'stylesheet';
				link.href = SPLIDE_CSS;
				document.head.appendChild(link);
			}

			var existing = document.querySelector('script[src="' + SPLIDE_JS + '"]');
			if ( existing ) {
				existing.addEventListener('load', function () { resolve(); });
				existing.addEventListener('error', reject);
				if ( typeof Splide !== 'undefined' ) resolve();
				return;
			}

			var script = document.createElement('script');
			script.src = SPLIDE_JS;
			script.onload = function () { resolve(); };
			script.onerror = reject;
			document.head.appendChild(script);
		});

		return loading;
	}

	function mount(root) {
		root.querySelectorAll('[data-kst-rec-slider]').forEach(function (el) {
			if ( el.classList.contains('is-initialized') ) return;
			if ( !el.querySelector('.splide__list') ) return;

			var slider = new Splide(el, {
				perPage: 3,
				perMove: 1,
				gap: '0.875rem',
				arrows: true,
				pagination: false,
				drag: true,
				omitEnd: true,
				speed: 450,
				easing: 'cubic-bezier(0.25, 0.72, 0.25, 1)',
				breakpoints: {
					474: { perPage: 2, gap: '0.75rem' }
				}
			});

			slider.mount();
			el.__kstSplide = slider;

			/* The cart drawer is display:none until it is opened, so the slider is
			   mounted inside a box with zero width and every slide is measured wrong.
			   Recalculate as soon as the drawer actually gets a width. */
			if ( typeof ResizeObserver !== 'undefined' ) {
				var lastWidth = 0;
				var observer = new ResizeObserver(function (entries) {
					var width = Math.round(entries[0].contentRect.width);
					if ( !width || width === lastWidth ) return;
					lastWidth = width;
					try { slider.refresh(); } catch (e) {}
				});
				observer.observe(el);
				el.__kstResize = observer;
			}
		});
	}

	function destroy(scope) {
		scope.querySelectorAll('[data-kst-rec-slider]').forEach(function (el) {
			if ( el.__kstResize ) {
				try { el.__kstResize.disconnect(); } catch (e) {}
				el.__kstResize = null;
			}
			if ( el.__kstSplide ) {
				try { el.__kstSplide.destroy(true); } catch (e) {}
				el.__kstSplide = null;
			}
		});
	}

	function init(root) {
		var scope = root || document;
		if ( !scope.querySelector('[data-kst-rec-slider]') ) return;
		/* quick add refetches the recommendations, so drop the previous instance
		   before mounting the replacement and leave no orphan resize listeners */
		destroy(scope);
		if ( typeof Splide !== 'undefined' ) { mount(scope); return; }
		loadSplide().then(function () { mount(scope); }).catch(function () {});
	}

	return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () { window.KST_REC.init(document); });
